import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import TextInput from "components/Input/TextInput.js";
import FloatInput from "components/Input/FloatInput";
import {
  CustomSelect,
} from "components/Input/Index.js";
import Button from "@mui/material/Button";
import { makeStyles, withStyles } from "@mui/styles";
import ImageList from "@mui/material/ImageList";
import moment from "moment";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";
import CustomSwitch from "components/Input/CustomSwitch.js";
import { putPoint } from "services/ConfigServices";
import styled from "styled-components";
import { dico } from "variables/lists/dico";
import { stateData, stateNotControlableData } from "variables/MBM/lists/equipments";
import AutocompleteInputMeters from "components/Input/AutocompleteInputMeters.js";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

function PointDialog(props) {
  const { closeModal, refetch, setLoading, setNotification, point, equipmentgroup } = props;
  const [name, setName] = useState(point.name || "");
  const [definition, setDefinition] = useState(point.definition || "");
  const [conversion, setConversion] = useState(point.conversion || "");
  const [groupid, setGroups] = useState(point.groupid ? "" + point.groupid : "");
  const [buttonDisabled, setButtonDisabled] = useState(true);

  const dicowithequipmentname = dico.map((row) => {
    let newrow = { ...row };
    newrow.name = row.equipmentname + " - " + row.name + " - " + row.unit + " (" + row.id + ")";
    return newrow;
  });

  const selectedDefinition = () => {
    let selected = dicowithequipmentname.find((obj)=>obj.id == definition);
    return selected;
  };

  const handleDefinitionChange = (selected) => { setDefinition(selected?.id || ""); };
  const handleNameChange = (event) => { setName(event.target.value); };
  const handleConversionChange = (event) => { setConversion(event.target.value); };

  const classes = useStyles();


  const handleSubmit = (event) => {
    updatePoint(event);
    closeModal();
  };

  useEffect(() => {
    if (!name || !definition || !groupid || groupid.length === 0 || groupid === '0')
      setButtonDisabled(true);
    else
      setButtonDisabled(false);
  },[name,groupid,definition]);




  const updatePoint = async (event) => {
    axios
      .put(
        putPoint("parameterscampaign"),
        {
          ...point,
          name,
          definition,
          conversion,
          groupid
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            "Content-Type": "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Point modifié");
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
        // setLoading(false);
      });
  };

  return (
    <>

      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={6} md={7} lg={7}>
            <div>
              <TextInput
                inputTitle={"Nom"}
                textInput={name}
                handleTextInputChange={handleNameChange}
              />
            </div>
            <div>
              <AutocompleteInputMeters
                specialWidth={"97%"}
                inputMargin={"1rem 0rem 0rem"}
                inputTitle={"Définition"}
                selected={selectedDefinition()}
                list={dicowithequipmentname}
                handleChange={(_, newValue) =>
                  handleDefinitionChange(newValue)
                }
              />
            </div>
            <div>
            <FloatInput
                inputTitle={"Conversion"}
                floatInput={conversion}
                handleFloatInputChange={handleConversionChange}
              />
            </div>
 
          </GridItem>
          <GridItem xs={12} sm={6} md={5} lg={5}>
            <div
              className={classes.treeVisible}
            >
              <TreeLabel>Choix du périmètre</TreeLabel>
              <ImageList rowHeight={140} className={classes.gridList} cols={1}>
                <EmbeddedEntitesTree
                  selectedIds={setGroups}
                  userSelectedIds={groupid}
                  filterfromnode={equipmentgroup}
                />
              </ImageList>
            </div>
          </GridItem>
        </GridContainer>
        <Button
          disabled={buttonDisabled}
          className={
            buttonDisabled
              ? classes.submitButtonDisabled
              : classes.submitButton
          }
          onClick={() => {
            handleSubmit();
          }}
        >
          Enregistrer
        </Button>
      </form>

    </>
  );
}

export default PointDialog;
